// extracted by mini-css-extract-plugin
export default {"rating":"XB-z","numberOfStars":"YB-z","count":"ZB-z","barGraphSpacing":"_B-z","barGraph":"aC-z"};